import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeSetLike, meshGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {MeshGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {meshGeometryAttributeLike} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {MeshGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {SplitOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/split-operator/geometry-split-operator-node"
import {
    GeometrySplitOperatorNode,
    splitOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/split-operator/geometry-split-operator-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

export type MeshGeometrySplitOperatorParameters = SplitOperatorParameters<MeshGeometryAttributeLikeNode, MeshGeometryAttributeSetLikeNode>

const definition: TemplateNodeDefinition<MeshGeometrySplitOperatorParameters> = {
    nodeClass: "MeshGeometrySplitOperator",
    validation: {
        parameters: splitOperatorParametersSchema(meshGeometryAttributeLike, meshGeometryAttributeSetLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometrySplitOperator
    extends GeometrySplitOperatorNode<2, MeshGeometryAttributeLikeNode, MeshGeometryAttributeSetLikeNode>
    implements MeshGeometryAttributeSetLikeNode
{
    get [meshGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
